/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ChatMessagesContainer.vue?vue&type=template&id=51b5dd30"
import script from "./ChatMessagesContainer.vue?vue&type=script&lang=js"
export * from "./ChatMessagesContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51b5dd30')) {
      api.createRecord('51b5dd30', component.options)
    } else {
      api.reload('51b5dd30', component.options)
    }
    module.hot.accept("./ChatMessagesContainer.vue?vue&type=template&id=51b5dd30", function () {
      api.rerender('51b5dd30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chat/chat-messages/ChatMessagesContainer.vue"
export default component.exports